export const AssessmentActivityStatus = {
  Complete: 'complete',
  InProgress: 'inprogress',
  NotStarted: 'notstarted',
} as const;

export type AssessmentActivityStatus =
  (typeof AssessmentActivityStatus)[keyof typeof AssessmentActivityStatus];
